import { render } from "./Angle.vue?vue&type=template&id=1a3fe192"
import script from "./Angle.vue?vue&type=script&lang=js"
export * from "./Angle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__